import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import NewReleaseBadge from "@/components/NewReleaseBadge";
import { Stars } from "@/components/BookReviews";

export default function BookCard({ product, index = 0, rating }) {
  return (
    <Link
      to={`/books/${product.id}`}
      data-testid={`book-card-${product.id}`}
      className="card-hover group block border border-white/10 bg-[#121212] fade-up"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <div className="relative overflow-hidden aspect-[2/3]">
        <img
          src={product.cover}
          alt={product.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
        {product.newRelease && <NewReleaseBadge />}
        {!product.available && (
          <div className="absolute top-4 left-4 flex items-center gap-2 font-mono-ui text-[10px] uppercase tracking-[0.2em] text-text-primary bg-black/70 border border-white/20 px-3 py-1">
            <Lock className="w-3 h-3" /> Coming Soon
          </div>
        )}
        <span
          className="absolute top-4 right-4 font-mono-ui text-[10px] uppercase tracking-[0.2em] px-3 py-1 border"
          style={{ color: product.accent, borderColor: `${product.accent}66` }}
        >
          {product.genre}
        </span>
      </div>
      <div className="p-6">
        <h3 className="font-serif-display text-2xl leading-tight">{product.title}</h3>
        {rating && (
          <div className="flex items-center gap-2 mt-3" data-testid={`book-card-rating-${product.id}`}>
            <Stars value={rating.avg} size="w-3.5 h-3.5" />
            <span className="font-mono-ui text-[10px] text-soft">
              {rating.avg.toFixed(1)} · {rating.count} review{rating.count === 1 ? "" : "s"}
            </span>
          </div>
        )}
        <p className="text-soft text-sm mt-2 line-clamp-2">{product.tagline}</p>
        <div className="mt-5 flex items-center justify-between">
          <span className="font-mono-ui text-sm text-primary-gold">
            {product.available ? `$${product.price.toFixed(2)}` : "—"}
          </span>
          <span className="font-mono-ui text-xs uppercase tracking-[0.18em] text-soft group-hover:text-primary-gold transition-colors">
            {product.available ? "View →" : "Notify →"}
          </span>
        </div>
      </div>
    </Link>
  );
}
